import { Show } from 'solid-js';
import { useTheme } from '../theme/ThemeProvider';

/**
 * Neo-Brutalism Background Component
 * Grid pattern with static wavy lines
 * Based on reference images: nb light bg.png & nb dark bg.png
 */
export function NeoBrutalismBackground() {
  const theme = useTheme();

  return (
    <Show when={theme.preset() === 'neo-brutalism'}>
      <>
        {/* Grid pattern */}
        <div class="neobrutal-grid" aria-hidden="true" />

        {/* SVG Curves */}
        <svg
          class="neobrutal-svg"
          viewBox="0 0 1200 800"
          preserveAspectRatio="xMidYMid slice"
          aria-hidden="true"
        >
          <defs>
            {/* Hard shadow filter */}
            <filter id="hardShadow" x="-20%" y="-20%" width="140%" height="140%">
              <feDropShadow dx="6" dy="6" stdDeviation="0" flood-color="#000000" />
            </filter>
          </defs>

          {/* Curve 1 - Top wave */}
          <path
            class="neobrutal-path neobrutal-path--1"
            d="M -50 200 Q 300 50, 600 150 T 1250 100"
            fill="none"
            stroke-width="24"
            filter="url(#hardShadow)"
          />

          {/* Curve 2 - Right side wave */}
          <path
            class="neobrutal-path neobrutal-path--2"
            d="M 1000 -50 Q 1100 200, 950 400 T 1050 850"
            fill="none"
            stroke-width="24"
            filter="url(#hardShadow)"
          />

          {/* Curve 3 - Bottom wave */}
          <path
            class="neobrutal-path neobrutal-path--3"
            d="M -50 600 Q 400 700, 800 550 T 1250 650"
            fill="none"
            stroke-width="24"
            filter="url(#hardShadow)"
          />
        </svg>
      </>
    </Show>
  );
}
